import { createApp } from 'vue';
import { required, sameAs, minLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { createMetaManager } from 'vue-meta';
import titlePlugin from '@/plugins/meta.js';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import dateFilter from '@/filters/date.filters';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import AutoReloadModule from '@/plugins/AutoReload';
import TheMask from 'vue-the-mask'
import Axios from 'axios';
import * as functions_app from '@/plugins/functions_app';


//Компаненты
import Autocomplete from '@/components/app/Autocomplete.vue';
import Message from "@/components/app/Message";
import DataInput from "@/components/app/DataInput";


async function initializeApp() {
  await store.dispatch('initializeApp');
}

async function createdApp() {


  // Создайте приложение
  const app = createApp(App);


  //Компаненты
  app.component('Autocomplete', Autocomplete);
  app.component('Message', Message);
  app.component('DataInput', DataInput);

  // Подключите глобальные функции
  Object.entries(functions_app).forEach(([key, value]) => {
    app.config.globalProperties[`$${key}`] = value;
  });


  // Подключите Axios как глобальное свойство
  app.config.globalProperties.$http = Axios;
  // Перехватчик ответов. Если 403 - не тот User-Auth-Key, то выходим на страницу логина
  Axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 403) {
        localStorage.removeItem('token')
        delete Axios.defaults.headers.common['User-Auth-Key']
        router.push('/login');
      }
      return Promise.reject(error);
    }
  );



const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

if (SpeechRecognition) {
  const recognition = new SpeechRecognition();
  recognition.lang = 'ru-RU';
  recognition.interimResults = true;
  recognition.maxAlternatives = 1;
  recognition.continuous = true; // 👈 ключевая настройка: слушать непрерывно

  let activeTextarea = null;
  let activeButton = null;
  let beforeText = '';
  let afterText = '';
  let finalText = '';
  let startPos = 0;
  let isManualStop = false;

  recognition.onstart = () => {
    if (activeButton) activeButton.classList.add('listening');
    finalText = '';
    if (!activeTextarea) return;

    startPos = activeTextarea.selectionStart;
    const value = activeTextarea.value;
    beforeText = value.slice(0, startPos);
    afterText = value.slice(startPos);
  };

  recognition.onresult = (event) => {
    if (!activeTextarea) return;

    let newFinal = '';
    let newInterim = '';

    for (let i = event.resultIndex; i < event.results.length; ++i) {
      const transcript = event.results[i][0].transcript;
      if (event.results[i].isFinal) {
        newFinal += transcript + ' ';
      } else {
        newInterim += transcript;
      }
    }

    if (newFinal) finalText += newFinal;

    const display = beforeText + finalText + newInterim + afterText;
    activeTextarea.value = display;
    activeTextarea.dispatchEvent(new Event('input'));

    const cursorPos = (beforeText + finalText + newInterim).length;
    activeTextarea.setSelectionRange(cursorPos, cursorPos);
  };

  recognition.onerror = (e) => {
    console.warn('SpeechRecognition error:', e.error);
  };

  recognition.onend = () => {
    if (!isManualStop && activeTextarea) {
      // 👇 Автоматически перезапускаем, если пользователь не нажал стоп
      try {
        recognition.start();
      } catch (e) {}
    } else {
      stopListening();
    }
  };

  function stopListening() {
    isManualStop = true;
    try {
      recognition.stop();
    } catch (e) {}
    if (activeButton) activeButton.classList.remove('listening');
    activeTextarea = null;
    activeButton = null;
  }

  function createMicButton(textarea) {
    if (textarea.nextSibling?.classList?.contains('voice-btn')) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'voice-btn';
    Object.assign(btn.style, {
      position: 'absolute',
      right: '8px',
      top: '8px',
      width: '24px',
      height: '24px',
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Crect fill='none' height='256' width='256'/%3E%3Crect fill='none' height='144' rx='40' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='16' width='80' x='88' y='24'/%3E%3Cline fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='16' x1='128' x2='128' y1='200' y2='232'/%3E%3Cpath d='M199.6,136a72.1,72.1,0,0,1-143.2,0' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='16'/%3E%3C/svg%3E")`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      opacity: '0.7',
      padding: '0',
      transition: 'transform 0.3s ease, opacity 0.2s ease, filter 0.3s ease',
      zIndex: 10,
    });

    const style = getComputedStyle(textarea);
    if (style.position === 'static') textarea.style.position = 'relative';

    btn.addEventListener('mouseenter', () => (btn.style.opacity = '1'));
    btn.addEventListener('mouseleave', () => (btn.style.opacity = '0.7'));

    btn.addEventListener('click', (e) => {
      e.stopPropagation();

      if (btn.classList.contains('listening')) {
        // 🟥 остановить вручную
        stopListening();
      } else {
        // 🟢 запустить
        isManualStop = false;
        stopListening();
        activeTextarea = textarea;
        activeButton = btn;
        try {
          recognition.start();
        } catch (err) {
          console.error('recognition.start error', err);
        }
      }
    });

    textarea.insertAdjacentElement('afterend', btn);
  }

  function addVoiceButtons() {
    document.querySelectorAll('textarea').forEach(createMicButton);
  }

  window.addEventListener('DOMContentLoaded', addVoiceButtons);
  const observer = new MutationObserver(() => addVoiceButtons());
  observer.observe(document.body, { childList: true, subtree: true });

  // ✨ Анимация при активном микрофоне
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    .voice-btn.listening {
      filter: drop-shadow(0 0 5px red);
      transform: scale(1.2);
      animation: pulse 1s infinite;
    }
    @keyframes pulse {
      0% { transform: scale(1.2); filter: drop-shadow(0 0 4px red); }
      50% { transform: scale(1.4); filter: drop-shadow(0 0 10px red); }
      100% { transform: scale(1.2); filter: drop-shadow(0 0 4px red); }
    }
  `;
  document.head.appendChild(styleEl);
} else {
  console.warn('SpeechRecognition API не поддерживается вашим браузером');
}



 
  // Глобальная функция
  app.config.globalProperties.Globalfilters = function (data) {
    console.log('глобальная функция. Вызывайте this.Globalfilters');
  };

  app.config.globalProperties.$filters = {
    date: dateFilter,
  };

  // Подключите плагины
  app.use(titlePlugin);


  app.use(VCalendar, {
    componentPrefix: 'v',
  });

  app.use(TheMask);
  app.config.globalProperties.$vuelidate = useVuelidate;

  // Создание менеджера мета-данных
  const metaManager = createMetaManager();

  // Использование менеджера мета-данных
  app.use(metaManager);

  app.use(AutoReloadModule, {
    config: {
      Enabled: true,
      CheckInterval: 60,
    },
    router: router,
    vm: app,
  });

  // Подключите маршрутизатор и хранилище
  app.use(router);
  app.use(store);

  // Добавьте состояние приложения
  app.mixin({
    data() {
      return {
        lang: localStorage.getItem('lang') || 'ru',
        quote_id: '',
        dataFilling: [],
        doubleClick: {
          date: '',
          click: '0'
        },
        titleName: '',
        title: [{ title: '', info: '' }],
        data: {
          isAuto: true,
          isFraght: false,
          order: {
            info: '',
            customer: '',
            carrier: ''
          },
          client: '',
          contractors: {
            info: '',
            detail: {}
          },
          leads: '',
        },
        overflowApp: {
          flag: false
        },
        status: {
          client: '',
          order: '',
          quotation: '',
          lead: ''
        },
        type: '',
        old_list: '',
        typeMBL: '',
      };
    },
  });


  await initializeApp();



  app.mount('#app');

}
createdApp();